import { PLUGIN } from "src/app/common/enums/plugins";
import { SLOT } from "src/app/common/enums/slot";
import { MODULES_CRM_IDS_MAP } from "../constants/modules-crm-ids-map";
import { CrmModule } from "../enums/permissions";

// re-export CrmModule enum
export { CrmModule };

/**
 * this type can be used if you don't know if the string is something like
 * `module-xxxxx` or a SLOT or PLUGIN like "grid-connections" or "noysee". It
 * can be converted to to a `CrmModule` by using the `toCrmModule()` function.
 */
export type AnyModuleType = CrmModule | SLOT | PLUGIN | `module-${number}`;

export function toCrmModule(slotOrPlugin: AnyModuleType): CrmModule {
  return isCrmModule(slotOrPlugin) ? slotOrPlugin : MODULES_CRM_IDS_MAP[slotOrPlugin];
}

function isCrmModule(module: AnyModuleType): module is CrmModule {
  return module.startsWith("module-");
}
